import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {LoginValidator, PasswordValidator, ValidationError} from "shared/validators";
import {Errors} from "shared/errors";

export class ChatCustomValidators {
    static error(error: Errors) {
        return {customValidatorError: {error: error}}
    }

    static loginValidator(allowSpaces: boolean): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return null;
            }

            try {
                LoginValidator.validate(value, allowSpaces)
            } catch (e) {
                if (e instanceof ValidationError) {
                    return this.error(e.error)
                }
            }

            return null
        }
    }

    static passwordValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return null;
            }

            try {
                PasswordValidator.validate(value)
            } catch (e) {
                if (e instanceof ValidationError) {
                    return this.error(e.error)
                }
            }

            return null
        }
    }

    static confirmPasswordValidator(passwordFormControl: FormControl): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (!value) {
                return null;
            }

            if (passwordFormControl.errors) return null

            try {
                PasswordValidator.validate(value)
            } catch (e) {
                if (e instanceof ValidationError) {
                    return this.error(Errors.PASSWORDS_NOT_EQUALS)
                }
            }

            if (passwordFormControl.value !== value) return this.error(Errors.PASSWORDS_NOT_EQUALS)

            return null
        }
    }
}